import React, { useEffect } from "react";
import { Table, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import { useWorkshopQueryModel } from "../workshopQueryModel";
import { IWorkshopQueryDetail } from "../workshopQueryType";
import YhTag from "@/components/YhTag";
import { useDictModel } from "@/views/base/dict/dictModel";
import { momentFormat } from "@/utils/utils";
import useNavModel from "@/model/navModel";
import { tableSize } from "@/utils/constants";
import YhTootip from "@/components/YhTootip";
type statusType = {
    "maintenance.return-visit": string, //已回访
    "maintenance.write-off": string, //已结款
    "maintenance.underway": string,//在修
    "maintenance.await": string,//待修
    "maintenance.trans": string,//已转接
    "maintenance.stock-io": string,//已出库
    "maintenance.settle": string,//已结算
    "maintenance.create": string,//已开单
    "maintenance.change": string,//已作废
    // "maintenance.create": string,    
    [key: string]: any
}

export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg,
        loadData, setSelectedRowKeys, reset
    } = useWorkshopQueryModel();
    const { getTreeNodeName } = useDictModel();
    const { selectedNavId, replaceNav, findNav } = useNavModel();
    const onLook = (code: string) => {
        let supplierEditKey = "4-1-3";
        replaceNav(
            selectedNavId,
            supplierEditKey,
            {
                id: code, mode: "look", parentInfo: { selectedNavId }
            },
            true
        );
    }
    useEffect(() => {
        loadData()
    }, [])
    // useEffect(() => {
    //     return () => {
    //         !findNav("6-1") && reset();
    //     }
    // }, [selectedNavId])
    const statusColor: statusType = {
        "maintenance.return-visit": 'lime', //已回访
        "maintenance.write-off": "green", //已结款
        "maintenance.underway": "geekblue",//在修
        "maintenance.await": "purple",//待修
        "maintenance.trans": "cyan",//已转接
        "maintenance.stock-io": "magenta",//已出库
        "maintenance.settle": "green",//已结算
        "maintenance.create": "blue",//已开单
        "maintenance.change": "red",//已作废

    }
    const columns: ColumnsType<IWorkshopQueryDetail> = [
        {
            title: '序号',
            fixed: "left",
            width: 60,
            render: (t, r, i) => i + 1
        }, {
            title: '工单单号',
            width: 120,
            dataIndex: 'maintenanceCode',
            render: (text: any, record: any,) => <YhTootip text={text} onClick={() => onLook(text)} />,
        }, {
            title: '工单状态',
            width: 80,
            dataIndex: 'status',
            render: (text) => <YhTag color={statusColor[text]} text={getTreeNodeName(text)} />,
        },
        {
            title: '维修工',
            width: 130,
            dataIndex: 'technicianNames',
            render: (text: any, record: any,) => <YhTootip text={text} style={{ width: '130px' }} />,
        },
        {
            title: '工时统计',
            width: 80,
            dataIndex: 'duration',
        }, {
            title: '客户名称',
            width: 150,
            dataIndex: 'customerName',
            render: (text: any) => <YhTootip text={text} />,
        },
        {
            title: '派工时间',
            width: 140,
            dataIndex: 'dispatchTime',
            render: (text: any, record: any,) => momentFormat(record.dispatchTime),
        }, {
            title: '预计完工时间',
            width: 140,
            dataIndex: 'expectedCompletionTime',
            render: (text: any, record: any,) => momentFormat(record.expectedCompletionTime),
        }, {
            title: '维修类型',
            width: 80,
            dataIndex: 'serviceNatureName',
        }, {
            title: '车牌号',
            width: 95,
            dataIndex: 'licensePlate',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '车辆品牌',
            width: 160,
            dataIndex: 'brandName',
            render: (text: any) => <YhTootip text={text} style={{ width: '160px' }} />,
        }, {
            title: '车辆类型',
            width: 150,
            dataIndex: 'vehicleTypeName',
            render: (text: any) => <YhTootip text={text} style={{ width: '150px' }} />,
        }, {
            title: '服务地点',
            width: 80,
            dataIndex: 'serviceLocationName',

        }, {
            title: '进厂时间',
            width: 130,
            dataIndex: 'enterTime',
            render: (text) => momentFormat(text)
        }, {
            title: '出厂时间',
            width: 160,
            dataIndex: 'deliveryTime',
            render: (text) => momentFormat(text)
        }, {
            title: '制单员',
            width: 60,
            dataIndex: 'createUser',
            render: (text: any) => <YhTootip text={text} />,
        },
        {
            title: '送修人',
            width: 150,
            dataIndex: 'contact',
        }, {
            title: '送车电话',
            width: 95,
            dataIndex: 'phone',
        }, {
            title: 'VIN码',
            width: 80,
            dataIndex: 'vin',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '车辆型号',
            width: 120,
            dataIndex: 'vehicleModel',
            render: (text: any) => <YhTootip text={text} />,
        },
        // {
        //     title: '工时费',
        //     width: 80,
        //     dataIndex: 'workingHoursAmount',
        //     render: (text) => `￥${repairFormatNum(text)}`
        // }, {
        //     title: '配件费',
        //     width: 80,
        //     dataIndex: 'materialScienceAmount',
        //     render: (text) => `￥${repairFormatNum(text)}`
        // }, {
        //     title: '费用合计',
        //     width: 80,
        //     dataIndex: 'totalAmount',
        //     render: (text) => `￥${repairFormatNum(text)}`
        // }, 
        {
            title: '结算类型',
            width: 80,
            dataIndex: 'payType',
            render: (text) => getTreeNodeName(text)
        }, {
            title: '结算方式',
            width: 80,
            dataIndex: 'settlementMethod',
        }, {
            title: '结算方',
            width: 80,
            dataIndex: 'settlementPartyName',
            render: (text: any) => <YhTootip text={text} />,
        },
        {
            title: '所属站点',
            width: 250,
            fixed: "right",
            dataIndex: 'shopName',
            render: (text: any) => <YhTootip text={text} style={{ width: 250 }} />,
        },
    ];
    useEffect(() => {
        loadData()
    }, [])

    //点击行选高亮
    const onRow = (id: string) => {
        let findIndex = selectedRowKeys.indexOf(id);
        let newSelectedRowKeys = [...selectedRowKeys];
        if (findIndex === -1) {
            newSelectedRowKeys.push(id);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            newSelectedRowKeys.splice(findIndex, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };

    return (
        <Table
            bordered
            style={{ cursor: "pointer" }}
            size={tableSize}
            rowKey={record => record.id as string}
            rowSelection={{
                onChange: (selectedRowKeys: React.Key[], selectedRows: IWorkshopQueryDetail[]) => {
                    setSelectedRowKeys(selectedRowKeys as string[]);
                },
                selectedRowKeys
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                showSizeChanger: true,
                ...pgCfg,
                defaultPageSize: 25,
                pageSizeOptions: ['15', '25', '50', '100', '200', '500'],
                position: ["bottomRight"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize }).then();
                }
            }}
            onRow={record => ({
                onClick: () => onRow(record.id as string),
                onContextMenu: (e) => {
                    e.preventDefault();
                    setSelectedRowKeys([record.id as string]);
                }
            })}
            scroll={{ x: 'max-content', y: 'calc(100vh - 340px)' }}
        />
    )
}
